import { Check } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/widgets/dialog';
import type { PdpDeliveryStoreItemVm } from '../viewModels/pdpDelivery.vm';

interface PdpStoreInventoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  stores: PdpDeliveryStoreItemVm[];
}

export function PdpStoreInventoryModal({
  open,
  onOpenChange,
  stores,
}: PdpStoreInventoryModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton
        className="max-h-[80vh] max-w-2xl gap-0 overflow-hidden p-0 sm:max-w-2xl"
      >
        <DialogHeader className="space-y-0 bg-[#f0f0f0] px-4 py-3 text-center">
          <DialogTitle className="text-sm font-medium uppercase tracking-wide text-gray-700">
            Product also available in
          </DialogTitle>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto p-2.5">
          <div className="grid grid-cols-2 gap-2">
            {stores.map((store) => (
              <div
                key={store.storeId}
                className="relative rounded-[7px] border border-[#59ac59] p-3 pl-10 text-[13px] leading-[18px]"
              >
                <span className="absolute left-2.5 top-[15px] flex h-[18px] w-[18px] items-center justify-center rounded-full bg-[#59ac59] text-white">
                  <Check className="h-3 w-3" strokeWidth={3} />
                </span>
                <p className="mb-1 font-primary font-semibold">{store.storeName}</p>
                <p className="font-medium text-gray-900">{store.storeAddress}</p>
                {store.contactNumber && (
                  <p className="font-medium text-gray-900">
                    Phone:{' '}
                    <a href={`tel:${store.contactNumber}`} className="text-[var(--link-blue)]">
                      {store.contactNumber}
                    </a>
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
